export const ProductFormatMixin = (Base) =>
  class extends Base {
    onEditorLoaded() {
      super.onEditorLoaded()
      this.selectProductFormat()
    }

    // called from the bridge and on init
    selectProductFormat(printessSelectedProductFormat) {
      if (!this.selectIdmlSectionPrefixInPrintessValue) { return }

      let targetProductFormat = printessSelectedProductFormat || this.initialIdmlSectionPrefixFormFieldValue

      this.idmlSectionPrefixInputTargets.forEach(input => {
        const isTarget = input.dataset.idmlSectionPrefix === targetProductFormat
        input.checked = isTarget
      });
    }
  };
